import Cookies from "js-cookie";
import { createActionType, createAsyncAction } from "./create-actions";

export const LOGIN = createActionType("LOGIN");
export const REGISTER = createActionType("REGISTER");
export const LOGOUT = createActionType("LOGOUT");
export const FORGET_PASSWORD = createActionType("FORGET_PASSWORD");
export const EDIT_PASSWORD = createActionType("EDIT_PASSWORD");

export const userLogin = (data: any) =>
  createAsyncAction(LOGIN, "/auth/login", "post", data);

export const userRegister = (data: any) =>
  createAsyncAction(REGISTER, "/auth/register", "post", data);

export const userLogout = () =>
  createAsyncAction(LOGOUT, "/auth/logout", "delete", undefined, {
    Authorization: `Bearer ${Cookies.get("token")}`,
  });

export const forgotPassword = (data: any) =>
  createAsyncAction(FORGET_PASSWORD, "/forget-password", "put", data);

export const editPassword = (data: any) =>
  createAsyncAction(EDIT_PASSWORD, "auth/edit-password", "put", data, {
    Authorization: `Bearer ${Cookies.get("token")}`,
  });
